import { defineStore } from 'pinia'
import config from '@/config'
import request from '@/helpers/request'
import { legalLinks } from '@/helpers/userData.js'

export const useI18nStore = defineStore('i18n', {
	state: () => ({
		language: null,
		customLanding: {
			lpid: {
				age_selection: {},
				age_selection_mature: {},
				female_funnel: {},
				main_loader: {},
				male_funnel: {},
			},
		},
	}),

	getters: {
		getLanguage(state) {
			return state.language
		},
		getCustomLanding(state) {
			return state.customLanding
		},
		getLegalLinks(state) {
			return legalLinks(state.language)
		},
	},

	actions: {
		setLanguage(language) {
			this.language = language
		},
		setCustomLanding(customLanding) {
			this.customLanding = customLanding
		},

		async loadCustomLandingData() {
			const localizationHost = `${config('ApiLocalization')}${this.getLanguage}`
			const customLandingData = await request(`${localizationHost}/custom-landing.json`)

			this.customLanding = customLandingData
		},
	},
})
